/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import type { ComponentProps } from 'react';

const styles = {
  reCAPTCHA: css`
    display: flex;
    justify-content: center;

    :nth-of-type(n) .grecaptcha-badge {
      display: none !important;
    }
  `,
};

type Props = ComponentProps<'div'> & { id: string };

const InvisibleRecaptchaContainer = ({ id, ...rest }: Props) => (
  <div {...rest} css={styles.reCAPTCHA} id={id} data-testid={id} data-size="invisible" />
);

export default InvisibleRecaptchaContainer;
